// The companion's log and the diagnostics export (decision 064, F420; PRD
// 02 RF-61). Under the host alone; the log is read again every five seconds.

import { useMutation, useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

import { NotOnThisPc } from "@/components/NotOnThisPc";
import { useHost } from "@/host/host";
import { LOCAL_REFRESH_MS, hostQueries } from "@/host/queries";

export const Route = createFileRoute("/pc/log")({
  component: Log,
});

function Log() {
  const host = useHost();
  if (!host) return <NotOnThisPc />;
  return <LogUnderHost />;
}

function LogUnderHost() {
  const host = useHost()!;
  const info = useQuery(hostQueries.info(host));
  const logs = useQuery({ queryKey: ["host", "logs"], queryFn: () => host.logsTail(300), refetchInterval: LOCAL_REFRESH_MS });
  const [exported, setExported] = useState<string | null>(null);
  const exporting = useMutation({
    mutationFn: () => host.exportDiagnostics(),
    onSuccess: (path) => setExported(path),
  });
  const logPath = info.data?.log_path ?? "";
  return (
    <div className="space-y-4">
      <header className="flex flex-wrap items-end gap-3">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">Log</h1>
          <p className="muted mono text-xs">{logPath}</p>
        </div>
        <span className="flex-1" />
        <button className="btn btn-sm" onClick={() => host.openPath(logPath)} disabled={!logPath}>
          Show file
        </button>
        <button className="btn btn-sm btn-primary" onClick={() => exporting.mutate()} disabled={exporting.isPending}>
          Export diagnostics
        </button>
      </header>
      {exporting.isError ? <p className="alert">{String(exporting.error)}</p> : null}
      {exported ? (
        <p className="notice text-xs">
          Diagnostics written to {exported} (logs, settings, local state, pending returns, uploads, and your airframe.db with registrations, SELCAL codes and placard texts replaced).{" "}
          <button className="underline" onClick={() => host.openPath(exported)}>
            Show file
          </button>
        </p>
      ) : null}
      <pre className="card mono max-h-[65vh] overflow-auto whitespace-pre-wrap" aria-label="log lines">
        {logs.data?.length ? logs.data.join("\n") : "The log is empty."}
      </pre>
    </div>
  );
}
